import { removeUndefinedFields } from "../helper";

const WET_OPTIONS = [
  {
    label: "No oil in Wet Filter Bowl",
    status: "",
    apiOptionKey: "noOilInWetFilterBowl",
  },
  {
    label: "Oil in bowl found contaminate",
    status: "",
    apiOptionKey: "oilInBowlFoundContaminate",
  },
  {
    label: "Oil level and condition found ok",
    status: "",
    apiOptionKey: "oilLevelAndConditionFoundOk",
  },
];

const DRY_OPTIONS = [
  {
    label: "Found dry and Clean",
    status: "",
    apiOptionKey: "foundDryAndClean",
  },
  {
    label: "Outer element got chocked",
    status: "",
    apiOptionKey: "outerElementGotChocked",
  },
  {
    label: "Inner element got chocked",
    status: "",
    apiOptionKey: "innerElementGotChocked",
  },
  {
    label: "Water Traces observed in filter element",
    status: "",
    apiOptionKey: "waterTracesObservedInFilterElement",
  },
  {
    label: "Oil traces observed in filter element",
    status: "",
    apiOptionKey: "oilTracesObservedInFilterElement",
  },
  {
    label: "Carbon soot observed in filter element",
    status: "",
    apiOptionKey: "carbonSootObservedInFilterElement",
  },
  {
    label: "Outer element found Punctured",
    status: "",
    apiOptionKey: "outerElementFoundPunctured",
  },
  {
    label: "Inner element found Punctured",
    status: "",
    apiOptionKey: "innerElementFoundPunctured",
  },
];

export const getAirFilterQuestions = (details) => {
  if (!details.airFilterType) {
    return [
      {
        label: "Air Filter Type",
        apiKey: "airFilterType",
        type: "RADIO",
        options: [
          { label: "WET", apiOptionKey: "airFilterTypeWet" },
          { label: "DRY", apiOptionKey: "airFilterTypeDry" },
        ],
      },
    ];
  }
  return [
    {
      label: "Air Filter Type",
      apiKey: "airFilterType",
      type: "RADIO",
      options: [
        { label: "WET", apiOptionKey: "airFilterTypeWet" },
        { label: "DRY", apiOptionKey: "airFilterTypeDry" },
      ],
    },
    {
      label: "Condition of Air filter",
      options: details.airFilterType === "WET" ? WET_OPTIONS : DRY_OPTIONS,
    },
    {
      label: "Last oil change date in wet air filter bowl",
      apiKey: "lastOilChangeDateInWetAirFilterBowl",
      type: "DATE",
      options: [],
    },
  ];
};

export const getTurbochargerQuestions = (details) => {
  const Q1 = {
    label: "Turbocharger Engines",
    apiKey: "turboChargerType",
    type: "RADIO",
    options: [
      {
        label: "WITH_INTER_COOLER_ENGINE",
        apiOptionKey: "WITH_INTER_COOLER_ENGINE",
      },
      {
        label: "WITHOUT_INTER_COOLER_ENGINE",
        apiOptionKey: "WITHOUT_INTER_COOLER_ENGINE",
      },
      {
        label: "NATURAL_ASPIRATION_ENGINES",
        apiOptionKey: "NATURAL_ASPIRATION_ENGINES",
      },
    ],
  };
  if (details.turboChargerType === "WITH_INTER_COOLER_ENGINE") {
    return [Q1, ...QUESTIONS_2];
  } else if (details.turboChargerType === "WITHOUT_INTER_COOLER_ENGINE") {
    return [Q1, ...QUESTIONS_3];
  } else if (details.turboChargerType === "NATURAL_ASPIRATION_ENGINES") {
    return [Q1, ...QUESTIONS_4];
  }
  return [Q1];
};

const QUESTIONS_2 = [
  {
    label: "Air filter to Turbocharger Hose Condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q1o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q1o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q1o3",
        status: "",
      },
    ],
  },
  {
    label: "Turbocharger to Inter cooler hose condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q2o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q2o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q2o3",
        status: "",
      },
    ],
  },
  {
    label: "Intercooler to Inlet Manidold hose condidtion",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s2q3o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s2q3o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s2q3o3",
        status: "",
      },
    ],
  },
  {
    label: "Condition of Turbocharger",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s2q4o2" },
      {
        label: "Found Compressor wheel fins damaged",
        status: "",
        apiOptionKey: "s2q4o2",
      },
      {
        label: "Found Turbine wheel fins damaged",
        status: "",
        apiOptionKey: "s2q4o3",
      },
      {
        label: "Found shaft broken",
        status: "",
        apiOptionKey: "s2q4o4",
      },
      {
        label: "Found Oil traces in Compressor end",
        status: "",
        apiOptionKey: "s2q4o5",
      },
      {
        label: "Found Oil Traces in Turbine end",
        status: "",
        apiOptionKey: "s2q4o6",
      },
    ],
  },
  {
    label: "Condition of Inter Cooler",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s2q5o1" },
      {
        label: "Found Core damaged",
        status: "",
        apiOptionKey: "s2q5o2",
      },
      {
        label: "Found Oil traces in Inter Cooler",
        status: "",
        apiOptionKey: "s2q5o3",
      },
    ],
  },
];

const QUESTIONS_3 = [
  {
    label: "Air filter to Turbocharger Hose Condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s3q1o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s3q1o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s3q1o3",
        status: "",
      },
    ],
  },
  {
    label: "Turbocharger to Inlet Manifold hose condition",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "s3q2o1",
        status: "",
      },
      {
        label: "Found Puncture / damage",
        apiOptionKey: "s3q2o2",
        status: "",
      },
      {
        label: "Found clamp loose",
        apiOptionKey: "s3q2o3",
        status: "",
      },
    ],
  },
  {
    label: "Condition of Turbocharger",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s3q3o1" },
      {
        label: "Found Compressor wheel fins damaged",
        status: "",
        apiOptionKey: "s3q3o2",
      },
      {
        label: "Found Turbine wheel fins damaged",
        status: "",
        apiOptionKey: "s3q3o3",
      },
      {
        label: "Found shaft broken",
        status: "",
        apiOptionKey: "s3q3o4",
      },
      {
        label: "Found Oil traces in Compressor end",
        status: "",
        apiOptionKey: "s3q3o5",
      },
      {
        label: "Found Oil Traces in Turbine end",
        status: "",
        apiOptionKey: "s3q3o6",
      },
    ],
  },
];

const QUESTIONS_4 = [
  {
    label: "Air filter to Inlet Manifold Hose Condition",
    options: [
      { label: "Found Intact", status: "", apiOptionKey: "s4q1o1" },
      { label: "Found Puncture / damage", status: "", apiOptionKey: "s4q1o2" },
      { label: "Found clamp loose", status: "", apiOptionKey: "s4q1o3" },
    ],
  },
  {
    label: "In Exhaust System",
    options: [
      {
        label: "Oil Wetness observed in Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o1",
      },
      {
        label:
          "No Oil / Coolant / Fuel traces Wetness observed in exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o2",
      },
      {
        label: "Blockage in Silincer tile pipe",
        status: "",
        apiOptionKey: "s4q2o3",
      },
      {
        label: "Coolant Traces observed in Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o4",
      },
      {
        label: "Unburnt Fuel coming out from Exhaust Manifold",
        status: "",
        apiOptionKey: "s4q2o5",
      },
      {
        label: "Blockage observed in DOC",
        status: "",
        apiOptionKey: "s4q2o6",
      },
      { label: "Blockage in DPF", status: "", apiOptionKey: "s4q2o7" },
    ],
  },
  {
    label: "In Intake System",
    options: [
      {
        label: "Oil Wetness observed in InInlet Manifold",
        status: "",
        apiOptionKey: "s4q3o1",
      },
      {
        label: "No Oil / Coolant traces Wetness observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o2",
      },
      {
        label: "Carbon Soot observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o3",
      },
      {
        label: "Coolant Traces observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o4",
      },
      {
        label: "Dust observed in Inlet Manifold",
        status: "",
        apiOptionKey: "s4q3o5",
      },
    ],
  },
  {
    label: "EGR Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q4o1" },
      {
        label: "EGR Valve found struck",
        status: "",
        apiOptionKey: "s4q4o2",
      },
    ],
  },
  {
    label: "EGR Cooler Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q5o1" },
      {
        label: "Found Coolant leakage from EGR Cooler",
        status: "",
        apiOptionKey: "s4q5o2",
      },
      {
        label: "Found EGR cooler clogged",
        status: "",
        apiOptionKey: "s4q5o3",
      },
    ],
  },
  {
    label: "Intake Throttle Valve Condition",
    options: [
      { label: "Found ok", status: "", apiOptionKey: "s4q6o1" },
      {
        label: "Valve found struck",
        status: "",
        apiOptionKey: "s4q6o2",
      },
    ],
  },
  {
    label: "Blow-by Condition",
    options: [
      {
        label: "No Visible blowby gas",
        status: "",
        apiOptionKey: "s4q7o1",
      },
      {
        label: "Visible blowby gas observed",
        status: "",
        apiOptionKey: "s4q7o2",
      },
      {
        label: "Visible blowby gas observed with Oil traces in breather tube",
        status: "",
        apiOptionKey: "s4q7o3",
      },
      {
        label: "Visible blowby gas observed with Oil throw in breather tube",
        status: "",
        apiOptionKey: "s4q7o4",
      },
    ],
  },
  {
    label: "Blow-by Value in LPM",
    type: "INPUT",
    keyboardType: "numeric",
    apiKey: "s4q8o1",
    options: [],
  },
];

export const AIR_FILTER_ACCORDION_TABS_QUESTIONS = {
  "Air Intake & Exhaust System": "",
  Aspiration: "",
  // "Natural Aspiration Engines": QUESTIONS_4
};

export const isSelected = (details, question, option) => {
  const { parentKey = "", apiKey = "", type = "" } = question;
  const { apiOptionKey, label } = option;
  if (question.type === "RADIO") {
    return details[apiKey] === option.label;
  }

  return details[apiOptionKey];
};

export const mappingDetailsToUIAirSystem = (details) => {
  const responseMapper = {
    airFilterType: details.airFilterType,
    turboChargerType: details.turboChargerType,
    lastOilChangeDateInWetAirFilterBowl:
      details.lastOilChangeDateInWetAirFilterBowl,
    attachments: details?.conditionAirFilter?.attachments,
    // DRY filter fields
    foundDryAndClean: details?.conditionAirFilter?.foundDryAndClean,
    outerElementGotChocked: details?.conditionAirFilter?.outerElementGotChocked,
    innerElementGotChocked: details?.conditionAirFilter?.innerElementGotChocked,
    waterTracesObservedInFilterElement:
      details?.conditionAirFilter?.waterTracesObservedInFilterElement,
    oilTracesObservedInFilterElement:
      details?.conditionAirFilter?.oilTracesObservedInFilterElement,
    carbonSootObservedInFilterElement:
      details?.conditionAirFilter?.carbonSootObservedInFilterElement,
    outerElementFoundPunctured:
      details?.conditionAirFilter?.outerElementFoundPunctured,
    innerElementFoundPunctured:
      details?.conditionAirFilter?.innerElementFoundPunctured,
    // WET filter fields
    noOilInWetFilterBowl: details?.conditionAirFilter?.noOilInWetFilterBowl,
    oilInBowlFoundContaminate:
      details?.conditionAirFilter?.oilInBowlFoundContaminate,
    oilLevelAndConditionFoundOk:
      details?.conditionAirFilter?.oilLevelAndConditionFoundOk,
  };

  const turboCharger = details?.turboCharger || {};

  switch (details?.turboChargerType) {
    case "WITH_INTER_COOLER_ENGINE":
      Object.assign(responseMapper, {
        s2q1o1: turboCharger?.airFilterToTurboChargerHoseCondition?.foundIntact,
        s2q1o2:
          turboCharger?.airFilterToTurboChargerHoseCondition
            ?.foundPunctureOrDamage,
        s2q1o3:
          turboCharger?.airFilterToTurboChargerHoseCondition?.foundClampLoose,

        s2q2o1:
          turboCharger?.turboChargerToInterCoolerHoseCondition?.foundIntact,
        s2q2o2:
          turboCharger?.turboChargerToInterCoolerHoseCondition
            ?.foundPunctureOrDamage,
        s2q2o3:
          turboCharger?.turboChargerToInterCoolerHoseCondition?.foundClampLoose,

        s2q3o1:
          turboCharger?.interCoolerToInletManifoldHoseCondition?.foundIntact,
        s2q3o2:
          turboCharger?.interCoolerToInletManifoldHoseCondition
            ?.foundPunctureOrDamage,
        s2q3o3:
          turboCharger?.interCoolerToInletManifoldHoseCondition
            ?.foundClampLoose,

        s2q4o1: turboCharger?.conditionOfTurboCharger?.foundOk,
        s2q4o2:
          turboCharger?.conditionOfTurboCharger
            ?.foundCompressorWheelFinsDamaged,
        s2q4o3:
          turboCharger?.conditionOfTurboCharger?.foundTurbineWheelFinsDamaged,
        s2q4o4: turboCharger?.conditionOfTurboCharger?.foundShaftBroken,
        s2q4o5:
          turboCharger?.conditionOfTurboCharger?.foundOilTracesInCompressorEnd,
        s2q4o6:
          turboCharger?.conditionOfTurboCharger?.foundOilTracesInTurbineEnd,

        s2q5o1: turboCharger?.conditionOfInterCooler?.foundOk,
        s2q5o2: turboCharger?.conditionOfInterCooler?.foundCoreDamaged,
        s2q5o3:
          turboCharger?.conditionOfInterCooler?.foundOilTracesInInterCooler,
      });
      break;

    case "WITHOUT_INTER_COOLER_ENGINE":
      Object.assign(responseMapper, {
        s3q1o1: turboCharger?.airFilterToTurboChargerHoseCondition?.foundIntact,
        s3q1o2:
          turboCharger?.airFilterToTurboChargerHoseCondition
            ?.foundPunctureOrDamage,
        s3q1o3:
          turboCharger?.airFilterToTurboChargerHoseCondition?.foundClampLoose,

        s3q2o1:
          turboCharger?.turboChargerToInletManifoldHoseCondition?.foundIntact,
        s3q2o2:
          turboCharger?.turboChargerToInletManifoldHoseCondition
            ?.foundPunctureOrDamage,
        s3q2o3:
          turboCharger?.turboChargerToInletManifoldHoseCondition
            ?.foundClampLoose,

        s3q3o1: turboCharger?.conditionOfTurboCharger?.foundOk,
        s3q3o2:
          turboCharger?.conditionOfTurboCharger
            ?.foundCompressorWheelFinsDamaged,
        s3q3o3:
          turboCharger?.conditionOfTurboCharger?.foundTurbineWheelFinsDamaged,
        s3q3o4: turboCharger?.conditionOfTurboCharger?.foundShaftBroken,
        s3q3o5:
          turboCharger?.conditionOfTurboCharger?.foundOilTracesInCompressorEnd,
        s3q3o6:
          turboCharger?.conditionOfTurboCharger?.foundOilTracesInTurbineEnd,
      });
      break;

    case "NATURAL_ASPIRATION_ENGINES":
      Object.assign(responseMapper, {
        s4q1o1:
          turboCharger?.airFilterToInletManifoldHoseCondition?.foundIntact,
        s4q1o2:
          turboCharger?.airFilterToInletManifoldHoseCondition
            ?.foundPunctureOrDamage,
        s4q1o3:
          turboCharger?.airFilterToInletManifoldHoseCondition?.foundClampLoose,
      });
      break;
  }

  Object.assign(responseMapper, {
    s4q2o1: details?.inExhaustSystem?.oilWetnessObservedInExhaustManifold,
    s4q2o2:
      details?.inExhaustSystem
        ?.noOilCoolantFuelTracesWetnessObservedInExhaustManifold,
    s4q2o3: details?.inExhaustSystem?.blockageInSilincerTilePipe,
    s4q2o4: details?.inExhaustSystem?.coolantTracesObservedInExhaustManifold,
    s4q2o5: details?.inExhaustSystem?.unburntFuelComingOutFromExhaustManifold,
    s4q2o6: details?.inExhaustSystem?.blockageObservedInDOC,
    s4q2o7: details?.inExhaustSystem?.blockageInDPF,

    s4q3o1: details?.inIntakeSystemSchema?.oilWetnessObservedInInletManifold,
    s4q3o2:
      details?.inIntakeSystemSchema
        ?.noOilCoolantFuelTracesWetnessObservedInInletManifold,
    s4q3o3: details?.inIntakeSystemSchema?.carbonSootObservedInInletManifold,
    s4q3o4: details?.inIntakeSystemSchema?.coolantTracesObservedInInletManifold,
    s4q3o5: details?.inIntakeSystemSchema?.dustObservedInInletManifold,

    s4q4o1: details?.egrCondition?.foundOk,
    s4q4o2: details?.egrCondition?.egrValveFoundStruck,

    s4q5o1: details?.egrCoolerCondition?.foundOk,
    s4q5o2: details?.egrCoolerCondition?.foundCoolantLeakageFromEGRCodoler,
    s4q5o3: details?.egrCoolerCondition?.foundEGRCoolerClogged,

    s4q6o1: details?.intakeThrottleValveCondition?.foundOkIntake,
    s4q6o2: details?.intakeThrottleValveCondition?.valveFoundStruck,

    s4q7o1: details?.blowByCondition?.noVisibleBlowByGas,
    s4q7o2: details?.blowByCondition?.visibleBlowByGasObserved,
    s4q7o3:
      details?.blowByCondition
        ?.visibleBlowByGasObservedWithOilTracesInBreatherTube,
    s4q7o4:
      details?.blowByCondition
        ?.visibleBlowByGasObservedWithOilThrowInBreatherTube,

    s4q8o1: details?.blowByValueInLPM,
  });

  return responseMapper;
};

export const infantChecklistAirSystem = (payload) => {
  const {
    airFilterType,
    turboChargerType,
    foundDryAndClean,
    outerElementGotChocked,
    innerElementGotChocked,
    waterTracesObservedInFilterElement,
    oilTracesObservedInFilterElement,
    carbonSootObservedInFilterElement,
    outerElementFoundPunctured,
    innerElementFoundPunctured,
    lastOilChangeDateInWetAirFilterBowl,
    noOilInWetFilterBowl,
    oilInBowlFoundContaminate,
    oilLevelAndConditionFoundOk,
    attachments,

    s2q1o1,
    s2q1o2,
    s2q1o3,

    s2q2o1,
    s2q2o2,
    s2q2o3,

    s2q3o1,
    s2q3o2,
    s2q3o3,

    s2q4o1,
    s2q4o2,
    s2q4o3,
    s2q4o4,
    s2q4o5,
    s2q4o6,

    s2q5o1,
    s2q5o2,
    s2q5o3,

    s3q1o1,
    s3q1o2,
    s3q1o3,

    s3q2o1,
    s3q2o2,
    s3q2o3,

    s3q3o1,
    s3q3o2,
    s3q3o3,
    s3q3o4,
    s3q3o5,
    s3q3o6,

    s4q1o1,
    s4q1o2,
    s4q1o3,

    s4q2o1,
    s4q2o2,
    s4q2o3,
    s4q2o4,
    s4q2o5,
    s4q2o6,
    s4q2o7,

    s4q3o1,
    s4q3o2,
    s4q3o3,
    s4q3o4,
    s4q3o5,

    s4q4o1,
    s4q4o2,

    s4q5o1,
    s4q5o2,
    s4q5o3,

    s4q6o1,
    s4q6o2,

    s4q7o1,
    s4q7o2,
    s4q7o3,
    s4q7o4,

    s4q8o1,
  } = payload;

  let requestPayload = {};
  let turboChargerWithInterCooler = {};
  let turboChargerWithOutInterCooler = {};
  let naturalAspirationEngines = {};

  if (airFilterType) {
    requestPayload.airFilterType = airFilterType;
  }

  if (turboChargerType) {
    requestPayload.turboChargerType = turboChargerType;
  }
  if (
    foundDryAndClean ||
    outerElementGotChocked ||
    innerElementGotChocked ||
    waterTracesObservedInFilterElement ||
    oilTracesObservedInFilterElement ||
    carbonSootObservedInFilterElement ||
    outerElementFoundPunctured ||
    innerElementFoundPunctured
  ) {
    requestPayload.airFilterType = "DRY";
    requestPayload.conditionAirFilter = {
      foundDryAndClean: foundDryAndClean,
      outerElementGotChocked: outerElementGotChocked,
      innerElementGotChocked: innerElementGotChocked,
      waterTracesObservedInFilterElement: waterTracesObservedInFilterElement,
      oilTracesObservedInFilterElement: oilTracesObservedInFilterElement,
      carbonSootObservedInFilterElement: carbonSootObservedInFilterElement,
      outerElementFoundPunctured: outerElementFoundPunctured,
      innerElementFoundPunctured: innerElementFoundPunctured,
      attachments: attachments || [],
    };
  }

  if (
    noOilInWetFilterBowl ||
    oilInBowlFoundContaminate ||
    oilLevelAndConditionFoundOk
  ) {
    requestPayload.airFilterType = "WET";
    requestPayload.conditionAirFilter = {
      noOilInWetFilterBowl: noOilInWetFilterBowl,
      oilInBowlFoundContaminate: oilInBowlFoundContaminate,
      oilLevelAndConditionFoundOk: oilLevelAndConditionFoundOk,
    };
  }

  if (lastOilChangeDateInWetAirFilterBowl) {
    requestPayload.lastOilChangeDateInWetAirFilterBowl =
      lastOilChangeDateInWetAirFilterBowl;
  }

  /**** Accordion 1 END HERE */
  if (s2q1o1 || s2q1o2 || s2q1o3) {
    turboChargerWithInterCooler.airFilterToTurboChargerHoseCondition = {
      foundIntact: s2q1o1,
      foundPunctureOrDamage: s2q1o2,
      foundClampLoose: s2q1o3,
    };
  }

  if (s2q2o1 || s2q2o2 || s2q2o3) {
    turboChargerWithInterCooler.turboChargerToInterCoolerHoseCondition = {
      foundIntact: s2q2o1,
      foundPunctureOrDamage: s2q2o2,
      foundClampLoose: s2q2o3,
    };
  }

  if (s2q3o1 || s2q3o2 || s2q3o3) {
    turboChargerWithInterCooler.interCoolerToInletManifoldHoseCondition = {
      foundIntact: s2q3o1,
      foundPunctureOrDamage: s2q3o2,
      foundClampLoose: s2q3o3,
    };
  }

  if (s2q4o1 || s2q4o2 || s2q4o3 || s2q4o4 || s2q4o5 || s2q4o6) {
    turboChargerWithInterCooler.conditionOfTurboCharger = {
      foundOk: s2q4o1,
      foundCompressorWheelFinsDamaged: s2q4o2,
      foundTurbineWheelFinsDamaged: s2q4o3,
      foundShaftBroken: s2q4o4,
      foundOilTracesInCompressorEnd: s2q4o5,
      foundOilTracesInTurbineEnd: s2q4o6,
    };
  }

  if (s2q5o1 || s2q5o2 || s2q5o3) {
    turboChargerWithInterCooler.conditionOfInterCooler = {
      foundOk: s2q5o1,
      foundCoreDamaged: s2q5o2,
      foundOilTracesInInterCooler: s2q5o3,
    };
  }

  if (
    turboChargerWithInterCooler.airFilterToTurboChargerHoseCondition ||
    turboChargerWithInterCooler.turboChargerToInterCoolerHoseCondition ||
    turboChargerWithInterCooler.interCoolerToInletManifoldHoseCondition ||
    turboChargerWithInterCooler.conditionOfTurboCharger
  ) {
    requestPayload.turboCharger = {
      airFilterToTurboChargerHoseCondition:
        turboChargerWithInterCooler.airFilterToTurboChargerHoseCondition,
      turboChargerToInterCoolerHoseCondition:
        turboChargerWithInterCooler.turboChargerToInterCoolerHoseCondition,
      interCoolerToInletManifoldHoseCondition:
        turboChargerWithInterCooler.interCoolerToInletManifoldHoseCondition,
      conditionOfTurboCharger:
        turboChargerWithInterCooler.conditionOfTurboCharger,
      conditionOfInterCooler:
        turboChargerWithInterCooler.conditionOfInterCooler,
    };
  }
  /**** Accordion 2 END HERE */

  if (s3q1o1 || s3q1o2 || s3q1o3) {
    turboChargerWithOutInterCooler.airFilterToTurboChargerHoseCondition = {
      foundIntact: s3q1o1,
      foundPunctureOrDamage: s3q1o2,
      foundClampLoose: s3q1o3,
    };
  }

  if (s3q2o1 || s3q2o2 || s3q2o3) {
    turboChargerWithOutInterCooler.turboChargerToInletManifoldHoseCondition = {
      foundIntact: s3q2o1,
      foundPunctureOrDamage: s3q2o2,
      foundClampLoose: s3q2o3,
    };
  }

  if (s3q3o1 || s3q3o2 || s3q3o3 || s3q3o4 || s3q3o5 || s3q3o6) {
    turboChargerWithOutInterCooler.conditionOfTurboCharger = {
      foundOk: s3q3o1,
      foundCompressorWheelFinsDamaged: s3q3o2,
      foundTurbineWheelFinsDamaged: s3q3o3,
      foundShaftBroken: s3q3o4,
      foundOilTracesInCompressorEnd: s3q3o5,
      foundOilTracesInTurbineEnd: s3q3o6,
    };
  }

  /**** Accordion 3 END HERE */

  if (s4q1o1 || s4q1o2 || s4q1o3) {
    naturalAspirationEngines.airFilterToInletManifoldHoseCondition = {
      foundIntact: s4q1o1,
      foundPunctureOrDamage: s4q1o2,
      foundClampLoose: s4q1o3,
    };
  }

  if (s4q2o1 || s4q2o2 || s4q2o3 || s4q2o4 || s4q2o5 || s4q2o6 || s4q2o7) {
    requestPayload.inExhaustSystem = {
      oilWetnessObservedInExhaustManifold: s4q2o1,
      noOilCoolantFuelTracesWetnessObservedInExhaustManifold: s4q2o2,
      blockageInSilincerTilePipe: s4q2o3,
      coolantTracesObservedInExhaustManifold: s4q2o4,
      unburntFuelComingOutFromExhaustManifold: s4q2o5,
      blockageObservedInDOC: s4q2o6,
      blockageInDPF: s4q2o7,
    };
  }

  if (s4q3o1 || s4q3o2 || s4q3o3 || s4q3o4 || s4q3o5) {
    requestPayload.inIntakeSystemSchema = {
      oilWetnessObservedInInletManifold: s4q3o1,
      noOilCoolantFuelTracesWetnessObservedInInletManifold: s4q3o2,
      carbonSootObservedInInletManifold: s4q3o3,
      coolantTracesObservedInInletManifold: s4q3o4,
      dustObservedInInletManifold: s4q3o5,
    };
  }

  if (s4q4o1 || s4q4o2) {
    requestPayload.egrCondition = {
      foundOk: s4q4o1,
      egrValveFoundStruck: s4q4o2,
    };
  }

  if (s4q5o1 || s4q5o2 || s4q5o3) {
    requestPayload.egrCoolerCondition = {
      foundOk: s4q5o1,
      foundCoolantLeakageFromEGRCodoler: s4q5o2,
      foundEGRCoolerClogged: s4q5o3,
    };
  }

  if (s4q6o1 || s4q6o2) {
    requestPayload.intakeThrottleValveCondition = {
      foundOk: s4q6o1,
      valveFoundStruck: s4q6o2,
    };
  }

  if (s4q7o1 || s4q7o2 || s4q7o3 || s4q7o4) {
    requestPayload.blowByCondition = {
      noVisibleBlowByGas: s4q7o1,
      visibleBlowByGasObserved: s4q7o2,
      visibleBlowByGasObservedWithOilTracesInBreatherTube: s4q7o3,
      visibleBlowByGasObservedWithOilThrowInBreatherTube: s4q7o4,
    };
  }

  if (s4q8o1) {
    requestPayload.blowByValueInLPM = s4q8o1;
  }
  if (
    turboChargerWithOutInterCooler.airFilterToTurboChargerHoseCondition ||
    turboChargerWithOutInterCooler.turboChargerToInletManifoldHoseCondition ||
    turboChargerWithOutInterCooler.conditionOfTurboCharger
  ) {
    requestPayload.turboCharger = {
      airFilterToTurboChargerHoseCondition:
        turboChargerWithOutInterCooler.airFilterToTurboChargerHoseCondition,
      turboChargerToInletManifoldHoseCondition:
        turboChargerWithOutInterCooler.turboChargerToInletManifoldHoseCondition,
      conditionOfTurboCharger:
        turboChargerWithOutInterCooler.conditionOfTurboCharger,
    };
  }
  if (naturalAspirationEngines.airFilterToInletManifoldHoseCondition) {
    requestPayload.turboCharger = {
      airFilterToInletManifoldHoseCondition:
        naturalAspirationEngines.airFilterToInletManifoldHoseCondition,
    };
  }

  /**** Accordion 4 END HERE */
  const cleanedPayload = removeUndefinedFields(requestPayload);
  return cleanedPayload;
};
